import { useDispatch, useSelector } from "react-redux";
import { siteContactSelector, getSiteContacts } from "../siteContactSlice";
import React from 'react'


export const useSiteContacts = () => {
    
    const dispatch = useDispatch();

    React.useEffect( () => {
        dispatch(getSiteContacts());
    }, [dispatch])

    const siteContacts = useSelector(siteContactSelector.selectAll);
    const siteContactsAreLoading = useSelector(x => x.site.siteContacts.isLoading);

    return [siteContacts, siteContactsAreLoading]
}